module.exports = __webpack_public_path__ + "img/red-helmet.edaa2c18.jpg";